import { createContext } from "react";
const DuplicateContentContext = createContext();
export default DuplicateContentContext;

